import { API_PATH } from '@yoweb/utils/constants/routes';
import { QUERY_CATEGORY_ID, QUERY_PAGINATION_TOKEN, QUERY_SEARCH_TERM, QUERY_TASK_ID, QUERY_TEMPLATE_ID } from './queryParams'; // API routes

export var API_AUTH_STATUS = "".concat(API_PATH, "/auth-status");
export var API_CALLBACK = "".concat(API_PATH, "/callback");
export var API_HEALTHZ = "".concat(API_PATH, "/healthz");
export var API_LOGIN = "".concat(API_PATH, "/login");
export var API_LOGOUT = "".concat(API_PATH, "/logout");
export var API_NYLAS_OAUTH_CALLBACK = "".concat(API_PATH, "/calendar/oauth/callback");
export var API_INVOICES = "".concat(API_PATH, "/invoices");
export var API_PAYMENT_METHODS = "".concat(API_PATH, "/account/payment-methods");
export var API_IMAGES = "".concat(API_PATH, "/images");
export var API_MY_REP = "".concat(API_PATH, "/account/my-rep");
export var API_FEEDBACK = "".concat(API_PATH, "/feedback");
export var API_HANDLE_SIGNUP_DISABLED = "".concat(API_PATH, "/handle-signup-disabled");
export var API_TASKS = "".concat(API_PATH, "/tasks");
export var API_TASK_COMPLETED_COUNT = "".concat(API_TASKS, "/completed-count");
export var API_TASKS_LIST_LITES = "".concat(API_TASKS, "/lites-list");
export var API_PDF = "".concat(API_PATH, "/pdf");
export var API_LATEST_FEEDBACK_PROMPT = "".concat(API_TASKS, "/latestFeedbackPrompt");
export var API_DISMISS_FEEDBACK_PROMPT = function API_DISMISS_FEEDBACK_PROMPT(taskId) {
  return "".concat(API_TASKS, "/").concat(taskId, "/dismissFeedbackPrompt");
};
export var API_TASKS_SKIP_INSTANCE = function API_TASKS_SKIP_INSTANCE(taskId) {
  return "".concat(API_TASKS, "/").concat(taskId, "/skip");
};
export var API_TASKS_REOPEN = function API_TASKS_REOPEN(taskId) {
  return "".concat(API_TASKS, "/").concat(taskId, "/reopen");
};
export var API_TASKS_FIRST_COMMENT = function API_TASKS_FIRST_COMMENT(taskId) {
  return "".concat(API_TASKS, "/").concat(taskId, "/first-comment");
};
export var API_TASKS_INTERACTION_CONTROLS = function API_TASKS_INTERACTION_CONTROLS(taskId, templateId) {
  var url = "".concat(API_TASKS, "/interaction-controls");
  var params = new URLSearchParams();

  if (taskId) {
    params.append(QUERY_TASK_ID, taskId);
  }

  if (templateId) {
    params.append(QUERY_TEMPLATE_ID, templateId);
  }

  if (params.toString()) {
    return url + "?".concat(params.toString());
  }

  return url;
};
export var API_CALENDAR = "".concat(API_PATH, "/calendar");
export var API_CALENDAR_AUTHENTICATE = "".concat(API_CALENDAR, "/authenticate");
export var API_OAUTH_CALENDAR_AUTHENTICATE = "".concat(API_CALENDAR, "/oauth/authenticate");
export var API_SUBSCRIPTION = "".concat(API_PATH, "/subscription");
export var API_SUBSCRIPTION_RESUME = "".concat(API_SUBSCRIPTION, "/resume");
export var API_SUBSCRIPTION_PAUSE = "".concat(API_SUBSCRIPTION, "/pause");
export var API_SUBSCRIPTION_PAUSE_REASONS = "".concat(API_SUBSCRIPTION, "/pause-reasons");
export var API_SUBSCRIPTION_CANCEL_REASONS = "".concat(API_SUBSCRIPTION, "/cancel-reasons");
export var API_SUBSCRIPTION_STOP_FEEDBACK = "".concat(API_SUBSCRIPTION, "/stop-feedback");
export var API_SUBSCRIPTION_CANCEL = "".concat(API_SUBSCRIPTION, "/cancel");
export var API_SUBSCRIPTIONS = "".concat(API_PATH, "/subscriptions");
export var API_SUBSCRIPTIONS_CANCEL = "".concat(API_SUBSCRIPTIONS, "/cancel");
export var API_SUBSCRIPTIONS_REACTIVATE = "".concat(API_SUBSCRIPTIONS, "/reactivate");
export var API_SUBSCRIPTIONS_CANCEL_FEEDBACK = "".concat(API_SUBSCRIPTIONS, "/feedback-cancel");
export var API_USER_ENTITLEMENT = "".concat(API_SUBSCRIPTIONS, "/get-entitlement");
export var API_TASK_TEMPLATE = "".concat(API_PATH, "/task-template");
export var API_QUESTION_IDENTIFIER = "".concat(API_PATH, "/task-template/question-identifier");
export var API_TASK_TEMPLATE_CATEGORY = "".concat(API_TASK_TEMPLATE, "/category");
export var API_TASK_TEMPLATE_CATEGORY_ID = function API_TASK_TEMPLATE_CATEGORY_ID(categoryId) {
  return "".concat(API_TASK_TEMPLATE, "/category/").concat(categoryId);
};
export var API_TASK_TEMPLATE_ID = function API_TASK_TEMPLATE_ID(taskTemplateId) {
  return "".concat(API_TASK_TEMPLATE, "/").concat(taskTemplateId);
};
export var API_FEATURED_TASK_TEMPLATE_ID = function API_FEATURED_TASK_TEMPLATE_ID(taskTemplateId) {
  return "".concat(API_TASK_TEMPLATE, "/featured/").concat(taskTemplateId);
};
export var API_TASK_TEMPLATE_SEARCH_DISCOVERY = function API_TASK_TEMPLATE_SEARCH_DISCOVERY(searchTerm, paginationToken) {
  var url = "".concat(API_TASK_TEMPLATE, "/discovery/search");
  var params = new URLSearchParams();

  if (searchTerm) {
    params.append(QUERY_SEARCH_TERM, searchTerm);
  }

  if (paginationToken) {
    params.append(QUERY_PAGINATION_TOKEN, paginationToken);
  }

  if (params.toString()) {
    return url + "?".concat(params.toString());
  }

  return url;
};
export var API_TASK_TEMPLATE_SAMPLE_TODOS = function API_TASK_TEMPLATE_SAMPLE_TODOS(categoryIds, paginationToken) {
  var url = "".concat(API_TASK_TEMPLATE, "/discovery");
  var params = new URLSearchParams();

  if (categoryIds) {
    params.append(QUERY_CATEGORY_ID, JSON.stringify(categoryIds));
  }

  if (paginationToken) {
    params.append(QUERY_PAGINATION_TOKEN, paginationToken);
  }

  if (params.toString()) {
    return url + "?".concat(params.toString());
  }

  return url;
};
export var API_TASK_TEMPLATE_HOME = "".concat(API_TASK_TEMPLATE, "/home");
export var API_TASK_TEMPLATE_HOME_CATEGORY = "".concat(API_TASK_TEMPLATE_HOME, "/category");
export var API_TASK_TEMPLATE_CUSTOM = "".concat(API_TASK_TEMPLATE, "/custom");
export var API_MEMBER_ACTIONS = "".concat(API_PATH, "/home/member-actions");
export var API_USER = "".concat(API_PATH, "/user");
export var API_USER_IMAGE = "".concat(API_USER, "/image");
export var API_USER_ACCOUNT_DELETION_FEEDBACK = "".concat(API_USER, "/account-deletion");
export var API_PASSWORD_CHANGED_CALLBACK = "".concat(API_USER, "/password-changed-callback");
export var API_USER_UPDATE_PASSWORD = "".concat(API_USER, "/update-password");
export var API_USER_FINISH_ONBOARDING = "".concat(API_USER, "/finish-onboarding");
export var API_MEMBER_PROFILE = "".concat(API_PATH, "/member-profile");
export var API_MEMBER_PROFILE_PERSONS = "".concat(API_MEMBER_PROFILE, "/persons");
export var API_MEMBER_PROFILE_HOMES = "".concat(API_MEMBER_PROFILE, "/homes");
export var API_MEMBER_PROFILE_VEHICLES = "".concat(API_MEMBER_PROFILE, "/vehicles");
export var API_MEMBER_PROFILE_PETS = "".concat(API_MEMBER_PROFILE, "/pets");
export var API_PROPOSALS = "".concat(API_PATH, "/proposals");
export var API_PROPOSALS_SHARE = function API_PROPOSALS_SHARE(proposalId) {
  return "".concat(API_PROPOSALS, "/").concat(proposalId, "/share");
};
export var API_MEDIA = "".concat(API_PATH, "/media");
export var API_MEDIA_THUMBNAIL = "".concat(API_MEDIA, "/thumbnail");
export var API_MEDIA_INFO = "".concat(API_MEDIA, "/info");
export var API_GUIDE = "".concat(API_PATH, "/guide");
export var API_GUIDE_IMAGE = function API_GUIDE_IMAGE(agentId) {
  return "".concat(API_GUIDE, "/").concat(agentId, "/image");
};
var API_DISCUSSIONS = "".concat(API_PATH, "/discussions");
export var API_DISCUSSIONS_TOKEN_REQUEST = "".concat(API_DISCUSSIONS, "/token-request");
export var API_DISCUSSIONS_CREATE_COMMENT = "".concat(API_DISCUSSIONS, "/create-comment");
export var API_DISCUSSIONS_COMMENTS = "".concat(API_DISCUSSIONS, "/comments");
export var API_DISCUSSIONS_CREATE_MESSAGES = "".concat(API_DISCUSSIONS, "/create-messages");
export var API_DISCUSSIONS_MESSAGES = "".concat(API_DISCUSSIONS, "/messages");
export var API_DISCUSSIONS_CHANNEL = "".concat(API_DISCUSSIONS, "/channel");
export var API_DISCUSSIONS_PARTICIPANT_READ = "".concat(API_DISCUSSIONS, "/participant-read");
export var API_MEMBER = "".concat(API_PATH, "/member");
export var API_MEMBER_STATIC_VALUES = "".concat(API_MEMBER, "/static-values");
export var API_MEMBER_SURVEY = "".concat(API_MEMBER, "/survey");
export var API_MEMBER_SURVEY_ID = function API_MEMBER_SURVEY_ID(surveyId) {
  return "".concat(API_MEMBER, "/survey/").concat(surveyId);
}; // Pages

export var PAGE_HOME = '/';
export var PAGE_TODO = '/todos';
export var PAGE_TODO_DETAILS = function PAGE_TODO_DETAILS(todoId) {
  return "/todos/".concat(todoId);
};
export var PAGE_TEMPLATE_DETAILS = function PAGE_TEMPLATE_DETAILS(taskTemplateId) {
  return "/todos/template/".concat(taskTemplateId);
};
export var PAGE_GUIDE = '/guide';
export var PAGE_HELP = '/help';
export var PAGE_PROPOSAL_SHARE = '/share';
export var PAGE_MEMBER_INTRODUCTION_STEP = function PAGE_MEMBER_INTRODUCTION_STEP(stepNum) {
  return "/member/introduction/step/".concat(stepNum);
};
export var PAGE_TODO_DETAIL = function PAGE_TODO_DETAIL(todoId) {
  return "todos/".concat(todoId);
}; // Pages - Account

export var PAGE_ACCOUNT = '/account';
export var PAGE_PROFILE = "".concat(PAGE_ACCOUNT, "/profile");
export var PAGE_PROFILE_TAB = function PAGE_PROFILE_TAB(tab) {
  return "".concat(PAGE_ACCOUNT, "/profile/").concat(tab);
};
export var PAGE_SUBSCRIPTION = "".concat(PAGE_ACCOUNT, "/subscription");
export var PAGE_PAYMENTS = "".concat(PAGE_ACCOUNT, "/payments");
export var PAGE_WALLET = "".concat(PAGE_ACCOUNT, "/wallet"); // Pages - Embed

export var PAGE_EMBED = '/embed';
export var PAGE_ACCOUNT_EMBED = "".concat(PAGE_EMBED, "/profile");
export var PAGE_FAQ_EMBED = "".concat(PAGE_EMBED, "/faq");
export var PAGE_PRIVACY_POLICY_EMBED = "".concat(PAGE_EMBED, "/privacy-policy");
export var PAGE_COOKIE_POLICY_EMBED = "".concat(PAGE_EMBED, "/cookie-policy");
export var PAGE_TERMS_OF_SERVICE_EMBED = "".concat(PAGE_EMBED, "/terms-of-service");
export var PAGE_COPYRIGHT_POLICY_EMBED = "".concat(PAGE_EMBED, "/copyright-policy");
export var PAGE_PRIVACY_NOTICE_CA_EMBED = "".concat(PAGE_EMBED, "/ca-privacy-notice");
export var PAGE_OPEN_SOURCE_ATTRIBUTION_EMBED = "".concat(PAGE_EMBED, "/open-source-attribution");
export var PAGE_TRAVEL_TERMS_OF_SERVICE_EMBED = "".concat(PAGE_EMBED, "/travel-terms-of-service");
export var PAGE_TRAVEL_REGISTRATION_EMBED = "".concat(PAGE_EMBED, "/travel-registration");
export var PAGE_TRAVEL_CONDITIONS_EMBED = "".concat(PAGE_EMBED, "/travel-conditions");
export var PAGE_PRIMEPRO_TERMS_OF_SERVICE_EMBED = "".concat(PAGE_EMBED, "/primepro-terms-of-service");
export var PAGE_SPECIFIED_COMMERCIAL_TRANSACTIONS_EMBED = "".concat(PAGE_EMBED, "/specified-commercial-transactions");
export var PAGE_WALLET_EMBED = "".concat(PAGE_EMBED, "/wallet");
export var PAGE_PROPOSALS_EMBED = function PAGE_PROPOSALS_EMBED(proposalId) {
  return "".concat(PAGE_EMBED, "/proposals/").concat(proposalId);
};